export const Roles = {
  ROLE_ALL: 'ROLE_ALL',
  ROLE_SUPERADMIN: 'ROLE_SUPERADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_ADMIN_CHURCH: 'ROLE_ADMIN_CHURCH',
  ROLE_ADMIN_WFL: 'ROLE_ADMIN_WFL',
  ROLE_ADMIN_SC: 'ROLE_ADMIN_SC',
  ROLE_DONATION_ADMIN: 'ROLE_DONATION_ADMIN',
  ROLE_DONATION_VIEWER: 'ROLE_DONATION_VIEWER',
  ROLE_REGISTER_ADMIN: 'ROLE_REGISTER_ADMIN',
  ROLE_REGISTER_VIEWER: 'ROLE_REGISTER_VIEWER',
  ROLE_NEW_MEMBER_ADMIN: 'ROLE_NEW_MEMBER_ADMIN',
  ROLE_NEW_MEMBER_VIEWER: 'ROLE_NEW_MEMBER_VIEWER',
  ROLE_EVENT_ADMIN: 'ROLE_EVENT_ADMIN',
  ROLE_EVENT_ACCOUNT: 'ROLE_EVENT_ACCOUNT',
  ROLE_EVENT_VIEW: 'ROLE_EVENT_VIEW',
  ROLE_ANALYTICS_ADMIN: 'ROLE_ANALYTICS_ADMIN',
  ROLE_ANALYTICS_CHURCH_HEALTH: 'ROLE_ANALYTICS_CHURCH_HEALTH',
  ROLE_ANALYTICS_CHART_DATA: 'ROLE_ANALYTICS_CHART_DATA',
  ROLE_GROUP_LEADER: 'ROLE_GROUP_LEADER',
  ROLE_ZONE_LEADER: 'ROLE_ZONE_LEADER',
  ROLE_HIM_LEADER: 'ROLE_HIM_LEADER',
  ROLE_WFL_ADMIN: 'ROLE_WFL_ADMIN',
  ROLE_WFL_TEACHER: 'ROLE_WFL_TEACHER',
  ROLE_WFL_TEAM: 'ROLE_WFL_TEAM',
  ROLE_WFL_MONITOR: 'ROLE_WFL_MONITOR',
  ROLE_CHURCH_MONITOR: 'ROLE_CHURCH_MONITOR',
  ROLE_USER: 'ROLE_USER',
} as const

export type Role = (typeof Roles)[keyof typeof Roles]
